import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgesQuery, BadgesService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { BadgeListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/badges/badge-list-item';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/loyalty/badges/badge-list-item';
import * as ɵngcc4 from '@ngx-translate/core';

function BadgeOverviewListComponent_ng_container_1_ng_container_1_ng_container_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "fgbcl-badge-list-item", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const badge_r6 = ctx.$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵclassProp("col-lg-2", ctx_r5.isList)("col-md-4", ctx_r5.isList)("col-4", ctx_r5.isList);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("badge", badge_r6);
} }
const _c0 = function (a0) { return { category: a0 }; };
function BadgeOverviewListComponent_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "h2", 3);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵtemplate(5, BadgeOverviewListComponent_ng_container_1_ng_container_1_ng_container_1_div_5_Template, 2, 7, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const category_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind2(2, 3, "badge.category.headers.screenreader", ɵngcc0.ɵɵpureFunction1(6, _c0, category_r4.Category)));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", category_r4.Category, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", category_r4.Badges);
} }
function BadgeOverviewListComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BadgeOverviewListComponent_ng_container_1_ng_container_1_ng_container_1_Template, 6, 8, "ng-container", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const badgesByCategories_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", badgesByCategories_r1);
} }
function BadgeOverviewListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BadgeOverviewListComponent_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const badgesByCategories_r1 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", badgesByCategories_r1 && badgesByCategories_r1.length);
} }
class BadgeOverviewListComponent {
    constructor(badgesQuery, badgesService) {
        this.badgesQuery = badgesQuery;
        this.badgesService = badgesService;
        this.isList = true;
    }
    ngOnInit() {
        this.badgesService.fetchBadges().toPromise();
        this.badgeByCategories$ = this.badgesQuery.selectAllBadgeCategories();
    }
}
BadgeOverviewListComponent.ɵfac = function BadgeOverviewListComponent_Factory(t) { return new (t || BadgeOverviewListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BadgesQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BadgesService)); };
BadgeOverviewListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BadgeOverviewListComponent, selectors: [["fgbcl-badge-overview-list"]], decls: 3, vars: 3, consts: [[1, "badge-overview-list", "badges-list-container"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "badge-subheading", "mt-4", "mb-0"], [1, "row"], [3, "col-lg-2", "col-md-4", "col-4", 4, "ngFor", "ngForOf"], [3, "badge"]], template: function BadgeOverviewListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BadgeOverviewListComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx.badgeByCategories$));
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc3.BadgeListItemComponent], pipes: [ɵngcc2.AsyncPipe, ɵngcc4.TranslatePipe], styles: [""] });
BadgeOverviewListComponent.ctorParameters = () => [
    { type: BadgesQuery },
    { type: BadgesService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BadgeOverviewListComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-badge-overview-list',
                template: "<div class=\"badge-overview-list badges-list-container\">\r\n  <!--Badge List-->\r\n  <ng-container *ngIf=\"badgeByCategories$ | async as badgesByCategories\">\r\n    <ng-container *ngIf=\"badgesByCategories && badgesByCategories.length\">\r\n      <ng-container *ngFor=\"let category of badgesByCategories\">\r\n        <h2\r\n          class=\"badge-subheading mt-4 mb-0\"\r\n          attr.aria-label=\"{{ 'badge.category.headers.screenreader' | translate: { category: category.Category } }}\"\r\n        >\r\n          {{ category.Category }}\r\n        </h2>\r\n        <div class=\"row\">\r\n          <div *ngFor=\"let badge of category.Badges\" [class.col-lg-2]=\"isList\" [class.col-md-4]=\"isList\" [class.col-4]=\"isList\">\r\n            <fgbcl-badge-list-item [badge]=\"badge\"></fgbcl-badge-list-item>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.BadgesQuery }, { type: ɵngcc1.BadgesService }]; }, null); })();

class BadgeOverviewListModule {
}
BadgeOverviewListModule.ɵfac = function BadgeOverviewListModule_Factory(t) { return new (t || BadgeOverviewListModule)(); };
BadgeOverviewListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BadgeOverviewListModule });
BadgeOverviewListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            BadgeListItemModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BadgeOverviewListModule, { declarations: function () { return [BadgeOverviewListComponent]; }, imports: function () { return [CommonModule,
        BadgeListItemModule, ɵngcc4.TranslateModule]; }, exports: function () { return [BadgeOverviewListComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BadgeOverviewListModule, [{
        type: NgModule,
        args: [{
                declarations: [BadgeOverviewListComponent],
                imports: [
                    CommonModule,
                    BadgeListItemModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [BadgeOverviewListComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BadgeOverviewListComponent, BadgeOverviewListModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-badges-badge-overview-list.js.map